<template>
  <div class="s-offers-slick">
    <div class="page-container">
      <div v-if="percentage" class="s-offers-slick__progress-bar">
        <ProgressBar :percentage="percentage" />
      </div>

      <SlickCarousel
        ref="slick"
        :key="'key-' + slickKey"
        class="s-offers-slick__slick"
        :options="slickOptions"
        @init="onInit"
        @beforechange="onBeforeChange">
        <div
          v-for="(item, index) in records"
          :key="index"
          class="s-offers-slick__slide item">
          <Offer :item="item" />
        </div>
      </SlickCarousel>
    </div>
  </div>
</template>

<script>
import * as lib from '../../lib/lib'
import ProgressBar from './../components/common/ProgressBar.vue'
import Offer from '../components/Offer.vue'
import SlickCarousel from '../components/common/SlickCarousel.vue'

export default {
  components: { ProgressBar, Offer, SlickCarousel },

  data() {
    return {
      percentage: 0,
      records: [],
      slickKey: 0,
      slickOptions: {
        infinite: false,
        autoplay: false,
        arrows: true,
        dots: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false,
        responsive: [
          {
            breakpoint: 992,
            settings: { slidesToShow: 1 },
          },
        ],
      },
    }
  },
  mounted() {
    const { records } = lib.getData('offersData')
    this.records = records
  },
  methods: {
    onInit(event, slick) {
      this.percentage = lib.getSlickProgressBarPercentage(slick)
    },
    onBeforeChange(event, slick) {
      setTimeout(() => {
        this.percentage = lib.getSlickProgressBarPercentage(slick)
      }, 100)
    },
  },
}
</script>
